import React from 'react'
import styled from '@emotion/styled'
import { Form, spacer } from 'stylist'
import Container from 'components/Container'
import { Col, GrowCol } from 'components/Col'
import { Bold, Slate } from 'components/Text'
import IntegerInput from 'components/IntegerInput'
import AddMoreButton from 'components/AddMoreButton'
import { CircleCancel } from 'components/Icon'
import QuotaWrapper from './QuotaWrapper'
import omit from 'lodash/omit'
import pullAt from 'lodash/pullAt'
import mapKeys from 'lodash/mapKeys'

/*
Example of the form elements this component is responsible for
{
  ...
    questions: {
      age: [18, 19, 20, 21, 22, 23, 24, 50, 51, 52, 53, 54, 55]
    },
    quotas: {
      age0: {
        limit: 50,
        questions: {
          gender: [18, 19, 20, 21, 22, 23, 24]
        }
      },
      age1: {
        limit: 50,
        questions: {
          gender: [50, 51, 52, 53, 54, 55]
        }
      }
    }
  ...
}
 */

const NoPaddingContainer = styled(Container)`
  & {
    padding: 0;
  }
`

const ExtraSmallInput = styled(IntegerInput)`
  width: 50px;
`

const RowCol = styled(Col)`
  flex-direction: row;
  align-items: center;
`

const SpaceAround = styled.div`
  margin: 0 ${spacer(2)};
`

const Remove = styled(CircleCancel)`
  margin: auto 0 auto ${spacer(2)};
`

class AgeRange extends React.Component {
  componentWillMount() {
    const { quota, setQuota } = this.props
    // Immediately activate quota input
    if (!quota) {
      setQuota({ limit: '' })
    }
  }

  /**
   * Updates the `quotas[age${index}]` form object.
   * The ranges themselves are automatically updated via
   * the low/high inputs being named.
   * @param {String} low
   * @param {String} high
   */
  handleChange = (low, high) => {
    const { quota, setQuota } = this.props
    setQuota({
      limit: quota.limit,
      questions: { age: [{ low, high }] }
    })
  }

  render() {
    const { index, range } = this.props
    return (
      <NoPaddingContainer>
        <RowCol>
          <ExtraSmallInput
            name={`questions.age[${index}].low`}
            onChange={e =>
              this.handleChange(Number(e.target.value), range.high)
            }
          />
          <SpaceAround>-</SpaceAround>
          <ExtraSmallInput
            name={`questions.age[${index}].high`}
            onChange={e => this.handleChange(range.low, Number(e.target.value))}
          />
        </RowCol>
      </NoPaddingContainer>
    )
  }
}

const AddRange = styled(AddMoreButton)`
  margin-left: -${spacer(2)};
`

class Age extends React.Component {
  componentWillMount() {
    const { setRanges, ranges } = this.props
    // Initialize with at least one row
    if (ranges.length === 0) {
      setRanges([{ high: '', low: '' }])
    }
  }

  handleAddRange = () => {
    const { setRanges, ranges } = this.props
    setRanges([...ranges, { high: '', low: '' }])
  }

  removeRangeQuota = (index, quotas, setQuotas) => {
    // omit this index from quotas object
    const newQuotas = mapKeys(omit(quotas, `age${index}`), (_, quotaKey) => {
      // decrement each key that has a quota key greater than the one removed
      if (quotaKey.startsWith('age')) {
        const keyIndex = Number(quotaKey.slice(3))
        if (keyIndex > index) {
          return `age${keyIndex - 1}`
        }
      }
      return quotaKey
    })
    setQuotas(newQuotas)
  }

  removeRangeQual = index => {
    const { setRanges, ranges } = this.props
    const newRanges = [...ranges]
    pullAt(newRanges, index)
    setRanges(newRanges)
  }

  handleRemoveRange = (index, quotas, setQuotas) => {
    this.removeRangeQuota(index, quotas, setQuotas)
    this.removeRangeQual(index)
  }

  render() {
    const { ranges } = this.props
    return (
      <QuotaWrapper
        name="age"
        qualOptions={ranges}
        autofillDisabled={ranges.length === 1}
        header={() => (
          <GrowCol>
            <Bold>
              <Slate>Ages</Slate>
            </Bold>
          </GrowCol>
        )}
        row={(option, index, setQuota, quota) => (
          <AgeRange
            index={index}
            range={option}
            setQuota={setQuota}
            quota={quota}
          />
        )}
        rowButton={index =>
          ranges.length === 1 ? null : (
            <Form.Field
              name="quotas"
              render={({ value: quotas, setValue: setQuotas }) => (
                <Remove
                  onClick={() =>
                    this.handleRemoveRange(index, quotas, setQuotas)
                  }
                />
              )}
            />
          )
        }
        footer={() => (
          <AddRange onClick={this.handleAddRange}>Add Response Range</AddRange>
        )}
      />
    )
  }
}

export default Age



// WEBPACK FOOTER //
// ./src/routes/estimate/subroutes/form/Age.js